
















































































































































import { Component, Vue } from "vue-property-decorator";
import VueGallerySlideshow from 'vue-gallery-slideshow';

//import Lightbox from 'vue-pure-lightbox';
/*import HelloWorld from "@/components/HelloWorld.vue"; 
import HelloI18n from "@/components/HelloI18n.vue";*/
//import Lightbox from "@/lightbox";

@Component({
  components: {
    VueGallerySlideshow
  }
})
export default class Home extends Vue {
	data() {
		return {
			images: [
				'/img-lightbox/cabanas-1.png',
				'/img-lightbox/cabanas-2.png',
				'/img-lightbox/cabanas-3.png',
				/*'/img/hotel_en_oaxaca-4.fcc9e301.jpg',
				'/img/hotel_en_oaxaca-4.fcc9e301.jpg',
				'/img/hotel_en_oaxaca-4.fcc9e301.jpg'*/
			],
			index: null,
			images1: [
				'/img-lightbox/hotel_en_oaxaca-1.jpg',
				'/img-lightbox/hotel_en_oaxaca-2.jpg',
				'/img-lightbox/hotel_en_oaxaca-3.jpg',
				'/img-lightbox/hotel_en_oaxaca-4.jpg',
				'/img-lightbox/hotel_en_oaxaca-5.jpg',
				'/img-lightbox/hotel_en_oaxaca-6.jpg',
			],
			index2: null
		};
	}
	
	
}
